import React from 'react';

interface TextButtonProps {
  svg?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  text?: string;
}

const TextButton: React.FC<TextButtonProps> = ({
  svg,
  className = '',
  onClick,
  disabled = false,
  text = 'Click Me',
}) => {
  const BASE_BUTTON_STYLES =
    'text-primary group flex items-center gap-2 text-base font-medium hover:text-blue-700 disabled:cursor-not-allowed disabled:!text-zinc-400';
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${className} ${BASE_BUTTON_STYLES}`}
    >
      <span className="border-primary border-b text-sm group-hover:border-blue-700 group-disabled:border-zinc-400 2xl:text-base">
        {text}
      </span>
      {svg}
    </button>
  );
};

export default TextButton;
